import * as React from 'react';
import { EditContext } from 'types';

/* ========= NOTES =========
 * the EditContext holds the overall state of the EditForm
 * this Context gets injected to all the Edit form controls like EditBackToListingLink, EditCancelButton, etc
 * the way the injection happens is that the Component's props get extended with the context
 * notice that all the components are exported like this: export default withEditContext({ComponentName});
 * take a look at withEditContext.tsx for how the context is added to the default props
 * plus EditBackToListingLink and EditCancelButton for different ways of consuming it
 * - further info:
 * https://reactjs.org/docs/context.html
 * ========== END ==========
 */

const editContext: EditContext = {} as EditContext;

export default React.createContext(editContext);
